import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "reservoirs";

const ReservoirsService = {
  getLevelPayload: async (data) => apiService.post(`${ENDPOINT}/levelPayload`, {
    currentUserId: store.state.currentUser?.uid,
    ...data,
  }),
};

export default ReservoirsService;
